import React, { useEffect, useState } from "react";
import Main from "../components/layout/Main";
import { Col, Row, Card, Button, Form, Select, Spin, Input, Modal } from "antd";
import useRequest from "../hooks/useRequest";
import * as XLSX from "xlsx";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { Severty, ShowToast } from "../helper/toast";
import { useNavigate } from "react-router";

const { Option } = Select;

const Home = () => {
  const [form] = Form.useForm();
  const [fileNames, setFileNames] = useState([]);
  const [importFile, setImportFile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [error, setError] = useState();
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);
  const [isProjectModalVisible, setIsProjectModalVisible] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  // const [dbHeaders, setDbHeaders] = useState([
  //   "P-NUMBER", "AREA", "PLOT NUMBER", "BUILDING NAME", "FLAT NUMBER", "NAME",
  //   "PHONE", "EMAIL", "MOBILE", "SECONDARY MOBILE", "BALCONY AREA", "PARKING NUMBER",
  //   "COMMON AREA", "FLOOR", "ROOMS DESCRIPTION", "ACTUAL AREA", "MUNICIPALITY NUMBER", "PROJECT", "COUNTRY", "NATIONALITY"
  // ]);
  const [dbHeaders, setDbHeaders] = useState([]);
  const [mismatchColumns, setMismatchColumns] = useState([]);
  const [matchColumns, setMatchColumns] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [bindings, setBindings] = useState({});
  const [bindingsNew, setBindingsNew] = useState({});
  const [uploadedHeaders, setUploadedHeaders] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [isTypeModalVisible, setIsTypeModalVisible] = useState(false);
  const propertyTypes = [
    { id: 50, name: "Other" },
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" },
    { id: 13, name: "Land" },
    { id: 14, name: "Plot" },
  ];
  useEffect(() => {
    fetchProject();
    fetchLocation();
    fetchColoums();
    fetchType();
  }, []);

  // const handleBindingChange = (uploadedColumn, dbColumn) => {
  //   setBindings((prevBindings) => ({
  //     ...prevBindings,
  //     [uploadedColumn]: dbColumn,
  //   }));
  // };
  // const handleBindingChange = (uploadedHeader, selectedDbHeaders) => {
  //   setBindings((prev) => ({
  //     ...prev,
  //     [uploadedHeader]: selectedDbHeaders
  //   }));
  // };

  // // Validate bindings for submission
  const validateBindings = () => {
    for (const column of mismatchColumns) {
      if (!bindings[column]) {
        return false;
      }
    }
    return true;
  };

  // const handleOk = async () => {
  //   if (!validateBindings()) {
  //     Modal.error({
  //       title: "Validation Error",
  //       content: "Please ensure all uploaded columns are properly mapped to existing columns.",
  //     });
  //     return;
  //   }
  //   console.log("Bindings to insert:", bindings);
  //   setModalVisible(false);
  // };

  const fileType = [
    ".csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const handleImport = (info) => {
    setLoading(true);
    const { file, fileList } = info;
    if (fileList?.length) {
      if (!fileType.includes(file.type)) {
        ShowToast("File format is not correct", Severty.ERROR);

        // setError("File format is not correct");
        setLoading(false); // Stop loading on error
        return false;
      }
      setError();
      const fileData = {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        uid: file.uid,
        status: "done",
        originFileObj: file.originFileObj,
        size: file.size,
        type: file.type,
        percent: file.percent,
      };
      setFile([fileData]);
      parseExcel(file.originFileObj);
    } else {
      // ShowToast('Missing Excel File', Severty.error);
      ShowToast("Missing Excel File", Severty.ERROR);
      setLoading(false); // Stop loading if no file is found
    }
  };


  const parseExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: "",
      });

      console.log("📄 Parsed Excel Data:", parsedData);

      const headers = parsedData[0] || [];
      const validHeaders = headers.filter((header) => header.trim() !== "");

      console.log("✅ Extracted Headers:", headers);
      console.log("✅ Valid Headers:", validHeaders);

      // Determine mismatches
      const mismatches = validHeaders.filter(
        (header) =>
          !dbHeaders.some((dbRow) =>
            Object.keys(dbRow).some(
              (dbKey) =>
                Array.isArray(dbRow[dbKey]) && dbRow[dbKey].includes(header)
            )
          )
      );

      console.log("❌ Mismatched Headers:", mismatches);

      const matchedColumns = validHeaders.filter(
        (header) => !mismatches.includes(header)
      );
      console.log("✅ Matched Columns:", matchedColumns);

      setUploadedHeaders(validHeaders);
      setMismatchColumns(mismatches);
      setMatchColumns(matchedColumns);

      // Branch check
      if (mismatches.length === 0) {
        console.log("➡️ Case: All headers matched");
        const formattedData = bindData(parsedData.slice(1), validHeaders);
        console.log("📦 Formatted Data:", formattedData);
        setImportFile(formattedData);
      } else if (mismatches.length === validHeaders.length) {
        console.log("➡️ Case: All headers mismatched");
        setImportFile(parsedData.slice(1));
        setModalVisible(true);
      } else {
        console.log("➡️ Case: Partial mismatches");
        setImportFile(parsedData.slice(1));
        setModalVisible(true);
        // If you want partially formatted data:
        // const formattedData = bindData(parsedData.slice(1), matchedColumns);
        // console.log("📦 Partial Formatted Data:", formattedData);
      }

      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
      console.log("📂 File Name:", fileNameWithoutExtension);

      setFileNames(fileNameWithoutExtension);
      setLoading(false);
    };
    reader.readAsArrayBuffer(file);
  };



  const bindData = (data, validHeaders) => {
    console.log(data, validHeaders);
    const transformedData = data.map((row) => {
      const transformedRow = {};

      Object.keys(bindings).forEach((uploadedHeader) => {
        const dbColumn = bindings[uploadedHeader];

        const uploadedHeaderIndex = uploadedHeaders.indexOf(uploadedHeader);

        // console.log(
        //   dbColumn,
        //   uploadedHeader,
        //   "HHHH Binding",
        //   uploadedHeaderIndex
        // );

        if (uploadedHeaderIndex !== -1) {
          const value = row[uploadedHeaderIndex] || "";
          // Concatenate the value to the existing transformedRow[dbColumn] if it exists
          transformedRow[dbColumn] =
            (transformedRow[dbColumn] || "") +
            (transformedRow[dbColumn] ? " " : "") +
            value;
        }
      });

      validHeaders.forEach((header, index) => {
        for (const dbKey in dbHeaders[0]) {
          const dbColumns = dbHeaders[0][dbKey];

          if (Array.isArray(dbColumns) && dbColumns.includes(header)) {
            const uploadedHeaderIndex = uploadedHeaders.indexOf(header);

            // console.log(dbKey, dbColumns, "HHHH Binding", header, row[index]);

            if (uploadedHeaderIndex !== -1) {
              const value = row[uploadedHeaderIndex] || "";
              // Concatenate the value to the existing transformedRow[dbColumn] if it exists
              transformedRow[dbKey] =
                (transformedRow[dbKey] || "") +
                (transformedRow[dbKey] ? " " : "") +
                value;
            } else {
              const value = row[index] || "";
              transformedRow[dbKey] =
                (transformedRow[dbKey] || "") +
                (transformedRow[dbKey] ? " " : "") +
                value;
              // Concatenate the value to the existing transformedRow[dbColumn] if it exists
              // transformedRow[dbKey] = value;
            }

            //  const value = row[index];
            //  transformedRow[dbKey] = (transformedRow[dbKey] || "") + (transformedRow[dbKey] ? " " : "") + value;
          }
          // if (Array.isArray(dbColumns) && dbColumns.includes(header)) {
          //   const concatenatedValue = dbColumns
          //     .map(col => {
          //       const uploadedHeaderIndex = validHeaders.indexOf(col);
          //       return uploadedHeaderIndex !== -1 ? row[uploadedHeaderIndex] || "" : "";
          //     })
          //     .join(" ");
          //   transformedRow[dbKey] = concatenatedValue.trim();
          // }
        }
      });

      // console.log(transformedRow, "transformedRow")

      return transformedRow;
    });

    return transformedData;
  };



  const handleBindingChange = (uploadedHeader, selectedDbHeader) => {
    setBindings((prev) => ({
      ...prev,
      [uploadedHeader]: selectedDbHeader,
    }));
    setBindingsNew((prev) => ({
      ...prev,
      [selectedDbHeader]: prev[selectedDbHeader]
        ? prev[selectedDbHeader] + "," + uploadedHeader
        : uploadedHeader,
    }));
  };


  const handleOk = async () => {
    console.log('handleOk clicked - starting loader');
    if (dbHeaders.length === 0) {
      ShowToast("Database columns not loaded. Please refresh and try again.", Severty.ERROR);
      return;
    }
    setModalLoading(true);
    if (!validateBindings()) {
      console.log('Validation failed - stopping loader');
      setModalLoading(false);
      Modal.error({
        title: "Validation Error",
        content: "Please ensure all uploaded columns are properly mapped.",
      });
      return;
    }
    console.log('Validation passed - processing data');
    try {
      const allColumns = [...mismatchColumns, ...matchColumns];
      const formattedData = await bindData(importFile, allColumns);
      console.log(formattedData, "formattedData");
      setImportFile(formattedData);
      ShowToast(`Data bound successfully (${formattedData.length} rows).`, Severty.SUCCESS);
      setModalVisible(false);
    } catch (error) {
      console.error("Error in binding data:", error);
      setModalLoading(false);
      ShowToast("Error processing data. Please check console and try again.", Severty.ERROR);
    } finally {
      if (!error) {
        setModalLoading(false);
      }
      console.log('Processing done - stopping loader');
    }
  };



  const requestAsync = (config) =>
    new Promise((resolve, reject) => {
      request({
        ...config,
        onSuccess: resolve,
        onError: reject,
      });
    });

  const checkFileNameExists = async (name) => {
    const normalizedName = String(name ?? "").trim().toLowerCase();
    if (!normalizedName) return false;

    const limit = 100;
    let page = 1;
    let totalPages = 1;

    while (page <= totalPages) {
      const data = await requestAsync({
        url: `/admin/downtown/list?listType=list&page=${page}&limit=${limit}&search=${encodeURIComponent(
          normalizedName
        )}`,
        method: "GET",
      });

      const listData = data?.data?.list || {};
      const docs = Array.isArray(listData?.docs) ? listData.docs : [];
      const exists = docs.some(
        (item) =>
          String(item?.file_name ?? "")
            .trim()
            .toLowerCase() === normalizedName
      );

      if (exists) return true;

      totalPages =
        Number(listData?.totalPages) ||
        Math.max(1, Math.ceil(Number(listData?.totalDocs || 0) / limit));
      page += 1;
    }

    return false;
  };

  const onSubmit = async (values) => {
    console.log("Import File:", importFile);
    console.log("Bindings:", bindings);

    if (error) return;

    if (fileNames.length) {
      let isDuplicateFileName = false;
      try {
        isDuplicateFileName = await checkFileNameExists(fileNames);
      } catch (e) {
        ShowToast("Unable to verify duplicate file name", Severty.ERROR);
        return;
      }
      if (isDuplicateFileName) {
        ShowToast("File with same name already exists", Severty.ERROR);
        return;
      }
      setLoading(true);
      const { year, location, project, tag, type } = values;

      const payload = {
        import_file: importFile,
        year,
        location,
        tag,
        type,
        project_name: project,
        file_name: fileNames,
        header_coloum: columnHeaders,
        bindings: bindingsNew,
      };

      // Send request
      request({
        url: "/admin/downtown/add-data",
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            navigate(`/data-excel/refine/${data.data._id}`);
            ShowToast(data.message, Severty.SUCCESS);
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(
            error.response.data.errors[0]?.message || "An error occurred",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } else {
      setError("Please Select an Excel File.");
    }
  };

  // const parseExcel = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(data, { type: "array" });
  //     const firstSheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[firstSheetName];
  //     const parsedData = XLSX.utils.sheet_to_json(worksheet, {
  //       header: 1,
  //       defval: "",
  //     });
  //     const headers = parsedData[0] || [];
  //     const validHeaders = headers.filter((header) => header !== "");

  //     const mismatches = headers.filter(header => !dbHeaders.includes(header));
  //     setUploadedHeaders(headers);
  //     setMismatchColumns(mismatches);
  //     setModalVisible(true);
  //     const formattedData = parsedData.slice(1).map((row) => {
  //       const rowData = {};
  //       validHeaders.forEach((header, index) => {
  //         const value = row[index];
  //         rowData[header] = typeof value === "string" ? value : value;
  //       });
  //       return rowData;
  //     });
  //     const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
  //     setImportFile(formattedData);
  //     setFileNames(fileNameWithoutExtension);
  //     setColumnHeaders(headers);
  //     setLoading(false);
  //   };
  //   reader.readAsArrayBuffer(file);
  // };

  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchLocation = () => {
    request({
      url: `/common/location-list`,
      method: "GET",
      onSuccess: (data) => {
        setLocation(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchType = () => {
    request({
      url: `/common/type-list`,
      method: "GET",
      onSuccess: (data) => {
        setTypeData(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchColoums = () => {
    request({
      url: `/common/db-coloum`,
      method: "GET",
      onSuccess: (data) => {
        console.log(data.data.data, "data.data");
        setDbHeaders(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const showProjectModal = () => setIsProjectModalVisible(true);
  const showTypeModal = () => setIsTypeModalVisible(true);
  const showLocationModal = () => setIsLocationModalVisible(true);
  const refreshData = () => {
    fetchProject();
    fetchLocation();
    fetchType();
  };
  const getColumnData = (key) => {
    if (dbHeaders.length > 0) {
      const header = dbHeaders[0]; // Accessing the first object
      return header[key] || []; // Return the corresponding value array or empty array
    }
    return [];
  };

  return (
    <Main>
      <Card title="Upload Excel File" className="for-card-title-mian">
        <Spin spinning={loading}>
          <Form id="create" form={form} onFinish={onSubmit} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col span={24}>
                <Form.Item
                  label="Select File"
                  name="import_file"
                  rules={[{ required: true, message: "" }]}
                >
                  <Dragger
                    fileList={file}
                    onRemove={() => setFile([])}
                    maxCount={1}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={handleImport}
                    customRequest={() => null}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or Drag File to This Area to Upload
                    </p>
                    <p className="ant-upload-hint">
                      Please Select an Excel File.
                    </p>
                  </Dragger>
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item
                  className="main-new-location-newh"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "5px",
                      }}
                    >
                      <span>Select Location</span>
                      <Button onClick={showLocationModal}>
                        + Add Location
                      </Button>
                    </div>
                  }
                  name="location"
                >
                  <Select
                    placeholder="Select Location"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {location.map((loc) => (
                      <Option key={loc._id} value={loc._id}>
                        {loc.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "5px",
                      }}
                    >
                      <span>Select Project</span>
                      <Button onClick={showProjectModal}>+ Add Project</Button>
                    </div>
                  }
                  name="project"
                  className="main-new-location-newh"
                >
                  <Select
                    placeholder="Select Project"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {project.map((proj) => (
                      <Option key={proj._id} value={proj._id}>
                        {proj.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "5px",
                      }}
                    >
                      <span>Select Type</span>
                      <Button onClick={showTypeModal}>+ Add Type</Button>
                    </div>
                  }
                  name="type"
                  className="main-new-location-newh"
                  rules={[{ required: true, message: "Please select a type!" }]}
                >
                  <Select
                    placeholder="Select Type"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {typeData.map((loc) => (
                      <Option key={loc._id} value={loc._id}>
                        {loc.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item label="Year" name="year">
                  <Select placeholder="Select a year">
                    {years.map((year) => (
                      <Option key={year} value={year}>
                        {year}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item label="Tag" name="tag">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24} md={24}>
                <Form.Item className="submit-new-main-buttonh">
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ alignItems: "left" }}
                    disabled={loading}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
      <Modal
        title="Mismatched Columns"
        width={900}
        visible={modalVisible}
        confirmLoading={modalLoading}
        onOk={() => handleOk()}
        onCancel={() => setModalVisible(false)}
      >
        <Row>
          <Col span={24} md={12} className="main-new-model-789">
            <h3>Uploaded Excel Columns</h3>
            <ul className="main-new-scrollbar">
              {mismatchColumns.map((header, index) => (
                <li key={index}>
                  {header}
                  <Select
                    placeholder="Bind to DB Column"
                    style={{ width: "100%", marginTop: "5px" }}
                    loading={modalLoading}
                    onChange={(value) =>
                      handleBindingChange(header, value && value.trim())
                    }
                  >
                    {dbHeaders.length > 0 &&
                      dbHeaders[0] &&
                      Object.keys(dbHeaders[0]).map((dbHeaderKey) => (
                        <Option key={dbHeaderKey} value={dbHeaderKey}>
                          {dbHeaderKey}
                        </Option>
                      ))}
                  </Select>
                </li>
              ))}
            </ul>
          </Col>
          <Col span={24} md={12} className="main-new-model-789">
            <h3>Existing Database Columns</h3>
            <ul className="main-new-scrollbar">
              {dbHeaders.length > 0 &&
                dbHeaders[0] &&
                Object.keys(dbHeaders[0]).map((dbHeaderKey, index) => {
                  const values = getColumnData(dbHeaderKey);
                  return (
                    <li key={index}>
                      <span>{dbHeaderKey} :- </span>
                      {values.length > 0 && ` (${values})`}{" "}
                      {/* Displaying values if available */}
                    </li>
                  );
                })}
            </ul>
          </Col>
        </Row>
      </Modal>
      {isLocationModalVisible && (
        <AddLocationModal
          visible={isLocationModalVisible}
          onClose={() => setIsLocationModalVisible(false)}
          onRefresh={refreshData}
        />
      )}
      {isTypeModalVisible && (
        <AddTypeModal
          visible={isTypeModalVisible}
          onClose={() => setIsTypeModalVisible(false)}
          onRefresh={refreshData}
        />
      )}

      {isProjectModalVisible && (
        <AddProjectModal
          visible={isProjectModalVisible}
          onClose={() => setIsProjectModalVisible(false)}
          onRefresh={refreshData}
        />
      )}
    </Main>
  );
};

const AddLocationModal = ({ visible, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [locationName, setLocationName] = useState("");
  const { request } = useRequest();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [form1] = Form.useForm();
  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = () => {
    request({
      url: `/common/country`,
      method: "GET",
      onSuccess: (data) => {
        console.log(data.data);
        setCountries(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchStates = (countryId) => {
    request({
      url: `/common/state/${countryId}`,
      method: "GET",
      onSuccess: (data) => {
        setStates(data.data.data);
        setCities([]); // Reset cities when country changes
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchCities = (stateId) => {
    request({
      url: `/common/city/${stateId}`,
      method: "GET",
      onSuccess: (data) => {
        setCities(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleAddLocation = async () => {
    setLoading(true);
    const values = await form1.validateFields();
    request({
      url: "/admin/location/add-location",
      method: "POST",
      data: {
        name: values.locationName,
        country: values.country,
        state: values.state,
        city: values.city,
      },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          onRefresh();
          onClose();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={visible}
      title="Add New Location"
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleAddLocation}
        >
          Add
        </Button>,
      ]}
    >
      <Form form={form1} layout="vertical">
        <Form.Item
          label="Location Name"
          name="locationName"
          rules={[{ required: true, message: "Please enter a location name!" }]}
        >
          <Input
            placeholder="Location Name"
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label="Country"
          name="country"
          rules={[{ required: true, message: "Please select a country!" }]}
        >
          <Select
            placeholder="Select Country"
            onChange={fetchStates}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {countries.map((country) => (
              <Option key={country.id} value={country.id}>
                {country.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: "Please select a state!" }]}
        >
          <Select
            placeholder="Select State"
            onChange={fetchCities}
            disabled={!form1.getFieldValue("country")}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {states.map((state) => (
              <Option key={state.id} value={state.id}>
                {state.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="City"
          name="city"
          rules={[{ required: true, message: "Please select a city!" }]}
        >
          <Select
            placeholder="Select City"
            disabled={!form1.getFieldValue("state")}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {cities.map((city) => (
              <Option key={city.id} value={city.id}>
                {city.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AddProjectModal = ({ visible, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [projectName, setProjectName] = useState("");
  const { request } = useRequest();
  const handleAddProject = () => {
    setLoading(true);
    request({
      url: "/admin/project/add-project",
      method: "POST",
      data: { name: projectName },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          onRefresh();
          onClose();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={visible}
      title="Add New Project"
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleAddProject}
        >
          Add
        </Button>,
      ]}
    >
      <Input
        placeholder="Project Name"
        value={projectName}
        onChange={(e) => setProjectName(e.target.value)}
      />
    </Modal>
  );
};
const AddTypeModal = ({ visible, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [projectName, setProjectName] = useState("");
  const { request } = useRequest();
  const handleAddProject = () => {
    setLoading(true);
    request({
      url: "/admin/type/add-type",
      method: "POST",
      data: { name: projectName },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          onRefresh();
          onClose();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={visible}
      title="Add New Type"
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleAddProject}
        >
          Add
        </Button>,
      ]}
    >
      <Input
        placeholder="Type Name"
        value={projectName}
        onChange={(e) => setProjectName(e.target.value)}
      />
    </Modal>
  );
};
export default Home;
